import { render, staticRenderFns } from "./modal-member-import.vue?vue&type=template&id=dd7b2582&scoped=true"
import script from "./modal-member-import.vue?vue&type=script&lang=js"
export * from "./modal-member-import.vue?vue&type=script&lang=js"
import style0 from "./modal-member-import.vue?vue&type=style&index=0&id=dd7b2582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7b2582",
  null
  
)

export default component.exports